/** @format */

export const dummyWidget = [
  {
    i: '1',
    type: 'shop_orders',
    size: 'normal'
  },
  {
    i: '2',
    type: 'shop_orders',
    size: 'medium'
  },
  {
    i: '3',
    type: 'shop_orders',
    size: 'large'
  },
  {
    i: '4',
    type: 'shop_orders',
    size: 'wide'
  },
  {
    i: '5',
    type: 'shop_orders',
    size: 'xwide'
  },
  {
    i: '6',
    type: 'shop_orders',
    size: '2xl'
  }
];
